import { Component, OnInit, Input, OnChanges, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { ServicoService } from '../../../services/servico.service';
import { AppService } from '../../../services/app.service';
import { StorageService } from '../../../services/storage.service';
import { GtagService } from '../../../services/gtag.service';
import { FbService } from '../../../services/fb.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DmCardEmailModal } from '../modal/dm-card-email/dm-card-email.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';

declare var $:any;

@Component({
  selector: 'dm-cart-add',
  templateUrl: './dm-cart-add.component.html',
  styleUrls: ['./dm-cart-add.component.scss']
})
export class DmCartAdd implements OnInit,OnChanges {
  
  @Input("dialog") _dialog:MatDialogRef<any>  = null;
  @Input("produto") produto                   = null;   
  @Input("categoria") categoria               = null;   
  @Input("configuracaoLoja") configuracaoLoja = null; 
  @Input("inCart") inCart                     = false;  
  @Input("estoque") estoque:any               = {
    total_in: 0,
    total_out: 0,
    quantidade_atual: 0,
    total_in_cart: 0
  } 
  public loader                               = false;
  public messageLoader = "";
  public dataItem:any  = {}
  public message       = {
    data: "",
    show: false,
    class: ""
  }
  public messageAdd = {
    show: false 
  }
  public subscribeMessage = null;
  public whatsapp = null;
  public route:any = null;
  public prefixo = "web";
  public valor1:any = 0;
  public valor2:any = 0;

  constructor(
    private api: ApiService,
    private _servico: ServicoService,
    private app: AppService, 
    private gtag: GtagService,
    private fb: FbService,
    private dialog: MatDialog,
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router
  ){

    this.route = location.protocol+"//"+location.host+this.router.url;

  }
  /**
   * 
   * To route
   * 
   */
  _toRoute(data){

    this.router.navigateByUrl(data); 

  }
  /**
   * 
   * Change Horário
   * 
   */
  _changeHorarioIn(value){

    this.dataItem.horario_in = value; 

  }
  /**
   * 
   * Change Horário
   * 
   */
  _changeHorarioOut(value){

    this.dataItem.horario_out = value;  

  }
  /**
   * 
   * Iniciliza o dataItem
   * 
   */
  initDataItem(){

    this.dataItem = {
      produto_id: this.produto.id,  
      nome: this.produto.nome,
      servico_id: this.produto.manage_id, 
      tipo_servico: null,
      tipo_servico_id: null,
      tipo_transporte: null,
      tipo_transporte_id: null,
      tipo_contratacao: null, 
      parametro_servico_id: this.produto.produto_parametro_servico_id,
      macro_regiao_id: null,
      macro_regiao: null,
      zona_regiao_hotel_id: null,
      zona_regiao_hotel: null,
      cidade_id: null,
      data_utilizacao: null,
      valor_adt: 0,
      valor_snr: 0,
      valor_chd: 0,
      valor_servico: 0,
      nome_hotel: null,
      hotel_id: null,
      codigo_moeda: "",
      qtd_adt: 0, 
      qtd_chd: 0,
      qtd_inf: 0,
      qtd_snr: 0,
      passageiros: [],
      voo: "",
      hora_voo: "",
      cia_aerea_text: "",
      cia_aerea_codigo: "",
      aeroporto: "",
      nome_cia_aerea: "",
      pedir_dados_voo: false,
      lotacao_maxima: 0,
      solicitar_endereco: false,
      endereco: "",
      hotel_fixo: false,
      vale_presente: this.produto.vale_presente,
      vale_presente_valor: 0,
      pacote_in_out: this.produto.pacote_in_out,
      data_chegada: "",
      aeroporto_chegada: "",
      cia_chegada_text: "",
      cia_chegada_codigo: "",
      voo_chegada: "",
      hora_chegada: "",
      data_partida: "",
      aeroporto_partida: "",
      cia_partida_text: "",
      cia_partida_codigo: "",
      voo_partida: "",
      hora_partida: "",  
      informar_horario: this.produto.informar_horarios,
      horario_in: "",
      horario_out: "",
      token: null,
      id_local_pick_up: null,
      id_local_drop_off: null,
      local_pick_up: "",
      local_drop_off: "",
      id_turno: 0,
      turno: null
    }

   

  }
  /**
   * 
   * Formatar horários
   * 
   */
  formatarHorarios(data,tipo){

    let out = [];

    for (let index = 0; index < data.length; index++) {
      
      if(tipo == data[index].tipo){
        out.push(data[index].horario);   
      }   
      
    }

    return out;

  }
  /**
   * 
   * Change Hora Partida
   * 
   */
   changeHoraVoo(value){

    this.dataItem.hora_voo = value;

  }
  /**
   * 
   * Change Hora Partida
   * 
   */
  changeHoraPartida(value){

    this.dataItem.hora_partida = value;

  }
  /**
   * 
   * Change Hora Partida
   * 
   */
  changeHoraChegada(value){ 
    
    this.dataItem.hora_chegada = value;

  }
  /**
   * 
   * Change Voo In
   * 
   */
  changeVoo(value){

    this.dataItem.voo = value;

  }
  /**
   * 
   * Change Voo In
   * 
   */
  changeVooIn(value){

    this.dataItem.voo_chegada = value;

  }
  /**
   * 
   * Change Voo Out
   * 
   */
  changeVooOut(value){

    this.dataItem.voo_partida = value;

  }
  /**
   * 
   * Change Aeroporto
   * 
   * @param value 
   * 
   */
  changeCiaIn(value){

    this.dataItem.cia_chegada_text   = value.text;
    this.dataItem.cia_chegada_codigo = value.codigo

  }
  /**
   * 
   * Change Aeroporto
   * 
   * @param value 
   * 
   */
  changeCiaOut(value){

    this.dataItem.cia_partida_text   = value.text;
    this.dataItem.cia_partida_codigo = value.codigo

  }
  /**
   * 
   * Change Aeroporto
   * 
   * @param value 
   * 
   */
  changeAeroportoIn(data){

    this.dataItem.aeroporto_chegada = data.text;

  }
  /**
   * 
   * Change Aeroporto
   * 
   * @param value 
   * 
   */
  changeAeroportoOut(data){

    this.dataItem.aeroporto_partida = data.text;

  }
  /**
   * 
   * Change Cia Aerea
   * 
   * @param value 
   * 
   */
  changeCia(data){

    this.dataItem.cia_aerea_text   = data.text;
    this.dataItem.cia_aerea_codigo = data.codigo;
  }
  /**
   * 
   * Change Aeroporto
   * 
   * @param value 
   * 
   */
  changeAeroporto(data){

    this.dataItem.aeroporto = data.text;

  }
  /**
   * 
   * Change a Região
   * 
   */
  changeMacroRegiao(value){

    this.dataItem.macro_regiao_id = value.idMacroRegiao;
    this.dataItem.macro_regiao    = value.macroRegiao;

  }
  /**
   * 
   * Change a Região
   * 
   */
  changeHotel(value){

    this.dataItem.nome_hotel = value.hotelPousada;
    this.dataItem.hotel_id   = value.idHotelPousada;

    if(value.idZonaRegiaoHotel.length > 0){
      this.dataItem.zona_regiao_hotel_id = value.idZonaRegiaoHotel;
    }
    if(value.zonaRegiaoHotel.length > 0){
      this.dataItem.zona_regiao_hotel = value.zonaRegiaoHotel;
    }
    if(value.idCidadeMunicipio.length > 0){
      this.dataItem.cidade_id = value.idCidadeMunicipio;
    }
    if(value.idCidadeMunicipio.length > 0){
      this.dataItem.cidade_id = value.idCidadeMunicipio;
    }
    if(value.solicitarEndereco === "true" || value.solicitarEndereco === true){
      this.dataItem.solicitar_endereco = true;
    }else{
      this.dataItem.solicitar_endereco = false;
    }

  }
  /**
   * 
   * Change Data Partida
   * 
   */
  changeDataRetorno(data){

    this.dataItem.data_partida = data; 

  }
  /**
   * 
   * Change QTDs
   * 
   * @param value 
   * 
   */
  changeQtds(value){

    this.dataItem.qtd_adt = value.qtd_adt;
    this.dataItem.qtd_chd = value.qtd_chd;
    this.dataItem.qtd_inf = value.qtd_inf;
    this.dataItem.qtd_snr = value.qtd_snr;

  }
  /**
   * 
   * Change Lista de Passgaeiros
   * 
   * @param value 
   * 
   */
  changeListaPassageiros(passageiros){

    this.dataItem.passageiros = passageiros;

  }
  /**
   * 
   * Return Recaptcha
   * 
   */
  getToken(){

    try{
      
      this.recaptchaV3Service.execute('importantAction')
      .subscribe((token) => {

       this.dataItem.token = token;

      },(response) => {  

        this.dataItem.token = null;

      });
    
    }catch(e){

      this.dataItem.token = null;

    }

  }
  /**
   * 
   * Inseri no Carrinho
   * 
   */
  addCart(validarDisponibilidade=true){

    try{
      
       if(this.configuracaoLoja.solicitar_email_pre_venda && this.dataItem.email == null){
          
          this.dialog.open(DmCardEmailModal,{
            width: "400px",
            height: "auto",   
            disableClose: true, 
            data: {   
              self: this
            } 
          });  
          return false;
          
        }
        if(this.dataItem.qtd_adt === 0 && this.dataItem.qtd_snr === 0 && this.dataItem.qtd_chd === 0){
          this.app.info("- Informe a quantidade de passageiros.","danger");
          return false;
        }
        let validation        = this._servico.validDadosPassageiros(this.dataItem.passageiros);
        this.subscribeMessage = null;    

        if(!validation.status){ 
          this.app.info(validation.data,"danger");
          return false;
        }
      this.loader         = true;
      this.messageLoader  = "Inserindo no carrinho. Aguarde!";

      this.recaptchaV3Service.execute('importantAction')
        .subscribe((token) => {
  
        this.dataItem.token = token;   

        this.api.loja().carrinho().store(this.dataItem).subscribe(response => {

          this.loader    = false;

          alert(response.status); 

          switch(response.status){
            case 1:
                               
              //this.cartService.emitirUpdateTotalCart.emit(response.data.total_cart);
              //this.cartService.emitirAddItem.emit(response.data.item);

              let valor  = null;
              if(this.dataItem.servico_tipo_id == 2){
                valor = this.dataItem.valor_servico;
              }else{
                valor = ((this.dataItem.valor_adt*this.dataItem.qtd_adt)+(this.dataItem.valor_snr*this.dataItem.qtd_snr)+(this.dataItem.valor_chd*this.dataItem.qtd_chd));
              }
              this.gtag.addCart({ 
                id: this.produto.id,
                nome: this.dataItem.nome, 
                categoria: this.categoria.titulo,
                valor: parseFloat(valor)
              });
              this.fb.addCartSingle({ 
                id: this.produto.id,
                nome: this.dataItem.nome, 
                categoria: this.categoria.titulo,
                valor: parseFloat(valor)
              });  
                     
            break;
            case 2:

              let message = "";

              for (let index = 0; index < response.data.length; index++) {
                
                message += "<p>"+response.data[index]+"</p>";
                
              }  

              this.app.info(message);  

            break;
            case 422:
                
              let messages = ""

              if(typeof(response.data.item) != "undefined"){
                if(response.data.item.length != 0){
                  messages += "<span>" 
                  messages += this.app.getErrors([response.data.item])
                  messages += "</span><br>"
                } 
              }  
    
              messages += "<span>";
                
              if(typeof(response.data.paxs) != "undefined"){
                if(response.data.paxs.length > 0){
                  messages += this.app.getErrors(response.data.paxs,true)
                }  
              }  
              messages += "</span>";

              this.app.info(messages,"danger");
            break;
            default:
              
              this.app.info("Houve um erro interno. Tente novamente ou entre em contato com a nossa equipe.<br> <strong>Detalhe:</strong> <br>"+response.data,"danger");  
            
            break;
          
          }

        },(response) => {

          this.loader         = false; 
          let error           = this.api.formatError(response);
          let messages        = error.message; 
          this.app.info(messages,"danger"); 

        });
      
      },(response) => { 

        this.loader   = false;
        this.app.info("Token de validação inválido. Recarregue a página para continuar.");

      });

    }catch(e){

      this.loader = false;  
      this.app.info(e.message); 

    }

  }
  /**
   * 
   * Set whatsapp
   * 
   */
  setWhatsapp(){

    if(this.configuracaoLoja != null){
      this.whatsapp = this.configuracaoLoja.whatsapp;
    }

  }
  /**
   * 
   * Open whatsapp
   * 
   */
  openWhatsApp(){ 

    let telefone = this.configuracaoLoja.whatsapp.replace("(","").replace(")","").replace("-","").replace(" ","");
    let numero   = "55"+telefone;
    let text = "Estou vendo o produto "+this.produto.nome+" ("+this.route+") e gostaria de mais informações.";

    window.open("https://"+this.prefixo+".whatsapp.com/send?phone="+numero+"&text="+text,"_blank"); 

  }
  /**
   * 
   * Set valor
   * 
   */
  setValor(){

    let data = "";

    if(this.produto.promocao){
      data = this.produto.promocao_valor.toString().split(".");
    }else{
      data = this.produto.valor.toString().split(".");  
    }

    this.valor1 = data[0];
    this.valor2 = data[1];


  }
  /***
  * 
  * Iniciliza as Funções
  * 
  ***/
  ngOnInit(){
    this.initDataItem();
    this.setWhatsapp(); 
    this.setValor();
    this.prefixo = this.app.isMobile() ? "api" : "web";
  }
  /**
   * 
   * Vefifica mudanças
   * 
   * @param changes 
   * 
   */
  ngOnChanges(changes:any):void{}

}
